import React from 'react';
import { useOffline } from '../contexts/OfflineContext';
import { WifiOff, RefreshCw, Cloud, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function OfflineBanner() {
  const { 
    isOnline, 
    isOfflineMode, 
    pendingCount, 
    isSyncing, 
    syncNow, 
    getLastSyncDisplay,
    canSync 
  } = useOffline();

  // Don't show banner if online and not in offline mode
  if (isOnline && !isOfflineMode && pendingCount === 0) {
    return null;
  }

  return (
    <div 
      className={`px-4 py-2 flex items-center justify-between text-sm ${
        !isOnline 
          ? 'bg-amber-100 text-amber-800 border-b border-amber-200' 
          : pendingCount > 0
            ? 'bg-blue-100 text-blue-800 border-b border-blue-200'
            : 'bg-green-100 text-green-800 border-b border-green-200'
      }`}
      data-testid="offline-banner"
    >
      <div className="flex items-center gap-2">
        {!isOnline ? (
          <>
            <WifiOff className="h-4 w-4" />
            <span className="font-medium">Offline mode</span>
            <span className="text-xs opacity-75">
              • Last synced: {getLastSyncDisplay()}
            </span>
          </>
        ) : pendingCount > 0 ? (
          <>
            <AlertCircle className="h-4 w-4" />
            <span className="font-medium">
              {pendingCount} pending change{pendingCount !== 1 ? 's' : ''} to sync
            </span>
          </>
        ) : (
          <>
            <Cloud className="h-4 w-4" />
            <span className="font-medium">Back online</span>
          </>
        )}
      </div>
      
      {canSync && (
        <Button 
          size="sm" 
          variant="outline" 
          onClick={syncNow}
          disabled={isSyncing}
          className="h-7 text-xs"
          data-testid="sync-now-btn"
        >
          <RefreshCw className={`h-3 w-3 mr-1 ${isSyncing ? 'animate-spin' : ''}`} />
          {isSyncing ? 'Syncing...' : 'Sync Now'}
        </Button>
      )}
    </div>
  );
}
